module.exports = __webpack_public_path__ + "img/sao_bg.41c9c170.png";